export default function getExtName(fileName) {
    return fileName.split(".").pop();
}
